<template>
  <v-hover v-slot:default="{ hover }">
    <v-card 
      max-width="350" 
      min-width="350"
      min-height="350"
      max-height="350"
      color="white" 
      :elevation="hover ? 9 : 2"
    >
      <v-card-title class="d-flex justify-space-between">
        <v-layout row wrap justify-space-between px-3>
          <v-chip
            label
            color="rgb(0,211,99,1.6)"
            class="white--text"
          >
            {{ immobileSellOrLocateValue(immobileInfo) }}
          </v-chip>
          <v-icon v-show="immobileFavorite" color="red">favorite</v-icon>
        </v-layout>
        <v-skeleton-loader
          v-if="showImageCard() == ''"
          type="image"
          width="320"
          height="150"
        ></v-skeleton-loader>
        <v-img
          v-else
          :src="showImageCard()"
          width="320"
          height="150"
          :class="{ 'on-hover': hover }"
        >
        </v-img>
        <v-chip
          small
          label
          dark
        >
          {{ immobileType(immobileInfo.tipo_imovel) }}
        </v-chip>
        <v-chip
          small
          label
        >
          {{ immobileFinality(immobileInfo.finalidade_imovel) }}
        </v-chip>
      </v-card-title>
      <v-card-text>
        <p>{{ immobileInfo.bairro + ' - ' + immobileInfo.cidade[1] + '/' + immobileInfo.estado[1] }}</p>
        <v-divider></v-divider>
        <div class="d-flex justify-space-around pt-3">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-icon >hotel</v-icon>
                {{ immobileInfo.total_quartos }}
              </div>
            </template>
            <span>Total de quartos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-icon>hot_tub</v-icon>
                {{ immobileInfo.total_suites }}
              </div>
            </template>
            <span>Total de suítes</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-icon>bathtub</v-icon>
                {{ immobileInfo.quantidade_banheiros }}
              </div>
            </template>
            <span>Total de banheiros</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-icon>drive_eta</v-icon>
                {{ immobileInfo.vaga_garagem_coberta + immobileInfo.vaga_garagem_descoberta }}
              </div>
            </template>
            <span>Total de garagens</span>
          </v-tooltip>
        </div>
      </v-card-text>
    </v-card>
  </v-hover>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import apiState from '@/ilios.store';

export default {
  name: 'ImmobileCard',

  props:{
    immobileInfo:{
      type: Object,
      required: true,
      default: null
    }
  },

  components: {
    
  },

  data: () => ({
    immobileFavorite: false,
    immobileTypes: [
      {id: 1, name: 'Casa' },
      {id: 2, name: 'Kitnet' },
      {id: 3, name: 'Sobrado' },
      {id: 4, name: 'Apartamento' },
      {id: 5, name: 'Sobreloja' },
      {id: 6, name: 'Terreno' },
      {id: 7, name: 'Sala' },
      {id: 8, name: 'Loja' },
    ],
    immobileFinalitys: [
      {id: 1, name: 'Venda' },
      {id: 2, name: 'Locação' },
      {id: 3, name: 'Locação/Venda' },
    ],
  }),

  mounted() {
  if (this.$cookies.isKey(this.immobileInfo.codigo_imovel)){
    this.immobileFavorite = true
  }
  },

  computed: {
 
  },

  watch: {

  },

  methods: {
    ...mapActions({

    }),

    ...mapGetters({
      getImmobilesImageList: 'Immobile/getImmobilesImageList'
    }),

    showImageCard(){
      var imagesList = this.getImmobilesImageList()
      var result = ''
      for (var element of imagesList){
        if(element.res_id == this.immobileInfo.id){
          result = element.url
          break
        }
      }
      return result
    },

    immobileType(typeId){
      var result = '---'
      this.immobileTypes.forEach(element => {
        if (element.id == typeId) result = element.name
      });
      return result
    },

    immobileFinality(finalityId){
      var result = '---'
      this.immobileFinalitys.forEach(element => {
        if (element.id == finalityId) result = element.name
      });
      return result
    },

    immobileSellOrLocateValue(objImmobile){
      var result = null
      var immobileTypeId = objImmobile.finalidade_imovel
      
      switch (immobileTypeId) {
        case 1:
          result = objImmobile.valor_c_doc
          break;
      
        case 2:
          result = objImmobile.valor_aluguel
          break;

        case 3:
          result = objImmobile.valor_c_doc
          break;
      }
      if(!result > 0) result = 'Consulte-nos'
      else result = 'R$ ' + result.toFixed(2)
      
      return result
    },
  },
};
</script>
<style scoped>
.v-image {
  transition: opacity .4s ease-in-out;
}

.v-image:not(.on-hover) {
  opacity: 0.7;
 }
</style>